import { FullAudit, IsActiveFlag, ScriptNumberModel } from '@/types';

export interface ScriptModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    clientUrl: string;
    scriptUrl?: string;
    includeJquery: boolean;
    isActive: boolean;
    numbers: ScriptNumberModel[];
}
